import CartCheckout from 'snippets/cart-checkout/cart-checkout'
import CartTotal from 'snippets/cart-total/cart-total'
import Price from 'snippets/price/price'
import { getLineItemRrp } from 'libs/cart'

function MiniCartButton({ cart, isFetching, isDisplayDiscountNote }) {
  let totalItemsDiscount = 0
  let totalDiscount = 0

  cart.items.map(item => (
    totalItemsDiscount += getLineItemRrp(item)
  ))
  totalDiscount = totalItemsDiscount - cart.total_price
  return (
    <div className="py-4 sticky bottom-0 z-10 bg-white md:pt-4 border-t order-1">
      {totalItemsDiscount > cart.total_price ? (
        <div className="px-4 md:px-6 pb-3">
          <div className="border-b text-green-content text-right font-medium pb-3" style={`color: ${window.minicartConfig.totalSavingColor}`}>
            <span className="text-sm">{translate.cart.savings_label}</span>
            <Price price={totalDiscount} className="inline-block text-sm" classSize="text-sm" />
          </div>
        </div>
      ) : null}
      <div className="px-4 md:px-6">
        <CartTotal isFetching={isFetching} price={cart.total_price} cartDiscount={totalItemsDiscount} className="p-0" />
        {isDisplayDiscountNote && (
          <div class="text-xs mb-4">{translate.product.promoDiscountAppliedDescription}</div>
        )}
        {GM_STATE.cart.miniDiscountMessageEnable && (
          <p className="mt-2 text-grey-1000 text-xs">{translate.cart.discount}</p>
        )}
        <CartCheckout type="mini-cart" className="flex gap-3 mt-4" cartCount={cart.item_count} />
      </div>
    </div>
  )
}

export default MiniCartButton
